export const MOBILE_BREAKPOINT = 580;
export const SMALL_TABLET_BREAKPOINT = 736;
export const TABLET_BREAKPOINT = 1024;
export const BIG_TABLET_BREAKPOINT = 1184;
export const DESKTOP_BREAKPOINT = 1280;

export const SEARCH_TABLET_BREAKPOINT = 1082;
